import { render, staticRenderFns } from "./payment-details.vue?vue&type=template&id=ce80e1ac"
import script from "./payment-details.ts?vue&type=script&lang=ts&external"
export * from "./payment-details.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports